import Moment from 'moment'
import { extendMoment } from 'moment-range'
import momentTZ from 'moment-timezone'
import * as defaultConst from '../../constants/default_constants'
const moment = extendMoment(Moment)

export default {
  isMandatory,
  isMandatoryParams,
  isMandatoryDate,
  isDate,
  isYear,
  isMonth,
  isValidFromTo,
  isValidStartEnd,
  regionTest,
  regionOverlapping,
  positiveInt,
  positiveFloat,
  maxLength,
  maxIntValue,
  isWorldWideRegion,
  isValidNegativeRegion,
  isEmail,
  _dateFromDate,
  _datesOverlapping
}

function isMandatory (store) {
  function _isMandatory (val) {
    if (!JSON.stringify(val) || val === null || val === false || val.length === 0) {
      return store.__('This is mandatory. ')
    }
  }
  return _isMandatory
}

function isMandatoryParams (store, exclude = null) {
  function _isMandatoryParams (val) {
    const record = store.cv.record
    const isExclude = exclude && Array.isArray(exclude) && exclude.length === 3 && record.has(exclude[0])
      ? record.has(exclude[0]) && record.get(exclude[0]) === exclude[1]
      : null
    const isSetVal = !JSON.stringify(val) || val === null || val === false || val.length === 0
    if (isSetVal && (exclude === null || isExclude === null || isExclude === exclude[2])) {
      return store.__('This is mandatory. ')
    }
  }
  return _isMandatoryParams
}

function isMandatoryDate (store) {
  function _isMandatoryDate (val) {
    if (val === false || (val && !moment(val).isValid())) {
      return store.__('Select the correct date from the calendar. ')
    } else if (!val) {
      return store.__('This is mandatory. ')
    }
  }
  return _isMandatoryDate
}

function isDate (store) {
  function _isDate (val) {
    if (val === false || (val && !moment(val).isValid())) {
      return store.__('Select the correct date from the calendar. ')
    }
  }
  return _isDate
}

function isYear (store) {
  function _isYear (val) {
    if (val === false || (val && (val < defaultConst.DATE_MIN_YEAR || val > defaultConst.DATE_MAX_YEAR))) {
      return (store.__('Invalid value. Set the value between ') + defaultConst.DATE_MIN_YEAR + store.__(' and ') + defaultConst.DATE_MAX_YEAR + '.')
    }
  }
  return _isYear
}

function isMonth (store) {
  function _isMonth (val) {
    if (val === false || (val && (val < 1 || val > 12))) {
      return store.__('Invalid value. Set the value between 1 and 12.')
    }
  }
  return _isMonth
}

function isValidFromTo (store) {
  function _isValidFromTo (val, vals) {
    const entity = vals.has('valid_from') ? vals : store.cv.record
    const validFrom = entity.has('valid_from') && entity.get('valid_from') && new Date(entity.get('valid_from'))
    const validTo = entity.has('valid_to') && entity.get('valid_to') && new Date(entity.get('valid_to'))
    if (validFrom && validTo && validFrom > validTo) {
      return store.__('"Valid from" is greater than "Valid to". ')
    }
  }
  return _isValidFromTo
}

function isValidStartEnd (store) {
  function _isValidStartEnd (val, vals) {
    const entity = vals.has('start_license_period') ? vals : store.cv.record
    const validStart = entity.has('start_license_period') && entity.get('start_license_period') && new Date(entity.get('start_license_period'))
    const validEnd = entity.has('end_license_period') && entity.get('end_license_period') && new Date(entity.get('end_license_period'))
    if (validStart && validEnd && validStart > validEnd) {
      return store.__('"Period start" is greater than "period end". ')
    }
  }
  return _isValidStartEnd
}

function isValidNegativeRegion (store) {
  function _isValidNegativeRegion (val) {
    if (val && val[0] && val[0] === '-') {
      return store.__('The negative region can not be used. ')
    }
  }
  return _isValidNegativeRegion
}

function isWorldWideRegion (store, entity) {
  function _isWorldWideRegion (vals) {
    const validFrom = vals.has('valid_from') && new Date(vals.get('valid_from'))
    const validTo = vals.has('valid_to') && new Date(vals.get('valid_to'))
    const items = store.options.has(entity)
      ? store.options.get(entity)
      : store.cv.record.get(entity)

    if (vals.has('regions') && vals.get('regions') !== 'WW') {
      const regionWW = items.filter((item) => {
        const itemFrom = new Date(item.valid_from)
        const itemTo = new Date(item.valid_to)
        if (((item.id && vals.get('id') !== item.id) ||
          (item.control_timestamp && item.control_timestamp !== vals.get('control_timestamp'))) &&
          vals.get('fp_category_code') === item.fp_category_code &&
          item.regions === 'WW' && itemFrom <= validFrom && itemTo >= validTo
        ) {
          return item
        }
      })
      store.manipWarning = (!regionWW || !regionWW.length) || false
    } else {
      store.manipWarning = false
    }
  }
  return _isWorldWideRegion
}

function regionTest (store) {
  function _regionTest (val) {
    if (val) {
      const notValidCodes = []
      const countries = store.options.get('Countries')
      const regionRegex = /^-?([A-Z]{2},){0,}[A-Z]{2}|([A-Z]{2}-[A-Z]{2})$/g
      if (!val.match(regionRegex)) {
        return val && val.indexOf(' ') > 0
          ? store.__('Wrong region definition. Do not use spaces between regions.')
          : store.__('Wrong region definition. ')
      }

      if (val && val.length >= 3 && (val.split(',').includes('WW') || val.split(',').includes('-WW'))) {
        return val[0] === '-'
          ? store.__('Wrong region definition, WW can\'t be with minus. ')
          : store.__('Wrong region definition, WW can\'t be mixed with other regions. ')
      }

      (val.charAt(0) === '-' ? val.substring(1) : val).split(',').forEach(c => {
        if (!countries.find(co => co.value === c)) {
          notValidCodes.push(store.__('Region code does not exist. '))
        }
      })
      return notValidCodes.length > 0
        ? store.__(`${notValidCodes.length} country code${notValidCodes.length > 1 ? 's' : ''} are not valid.`)
        : undefined
    }
  }
  return _regionTest
}

function _dateFromDate (date) {
  if (!date || !moment(date).isValid()) {
    return []
  } else {
    const mValue = moment(typeof date === 'string' && date.length === 10
      ? date + defaultConst.DATE_TIME_UTC
      : date).utc()
    return [mValue.year(), mValue.month(), mValue.date(), mValue.hour(), mValue.minute(), mValue.second()]
  }
}

function _datesOverlapping (currentFrom, currentTo, compareFrom, compareEnd, region = 'WW', utc1 = null, utc2 = null, store = null) {
  const overlapps = []
  const zones = (
    region && store && store.options.has('timeZonesList') && store.options.get('timeZonesList') &&
    store.options.get('timeZonesList').filter(i => i.country === region)
  ) || []

  zones && zones.map(timeZ => {
    const currentFromZ = utc1 ? new Date(Date.UTC(..._dateFromDate(currentFrom))) : momentTZ([..._dateFromDate(currentFrom)]).tz(timeZ.zone)
    const currentToZ = utc1 ? new Date(Date.UTC(..._dateFromDate(currentTo))) : momentTZ([..._dateFromDate(currentTo)]).tz(timeZ.zone)
    const compareFromZ = utc2 ? new Date(Date.UTC(..._dateFromDate(compareFrom))) : momentTZ([..._dateFromDate(compareFrom)]).tz(timeZ.zone)
    const compareEndZ = utc2 ? new Date(Date.UTC(..._dateFromDate(compareEnd))) : momentTZ([..._dateFromDate(compareEnd)]).tz(timeZ.zone)

    const cRange = currentFromZ && currentToZ && moment.range(currentFromZ, currentToZ)
    const nRange = compareFromZ && compareEndZ && moment.range(compareFromZ, compareEndZ)

    if (moment(currentFromZ).isSame(compareEndZ) ||
      moment(compareFromZ).isSame(currentToZ) ||
      cRange.overlaps(nRange) ||
      nRange.overlaps(cRange)) {
      overlapps.push(timeZ)
    }
  })
  return overlapps.length > 0
}

function regionOverlapping (store, exclude = null, fromEntity = null) {
  // description:
  // exclude = [key, value, boolean] || null
  // fromEntity = true if validator is runing inside entity || null
  function _regionOverlapping (val, vals) {
    let errors = ''
    const record = store.cv.record
    const isExclude = exclude && Array.isArray(exclude) && exclude.length === 3 && record.has(exclude[0])
      ? record.has(exclude[0]) && record.get(exclude[0]) === exclude[1]
      : null
    if (val && (exclude === null || isExclude === null || isExclude === exclude[2])) {
      const countries = store.options.get('Countries')
      const saleType = record && record.has('type_sale') && record.get('type_sale').toString().toUpperCase()
      const items1 = record.has('pricings') ? record.get('pricings') : record.get('flyprivate_video_pricing')
      const items2 = fromEntity
        ? items1
        : [{
          id: (vals.has('id') ? vals.get('id') : null),
          control_timestamp: (vals.has('control_timestamp') ? vals.get('control_timestamp') : null),
          regions: (vals.has('regions') ? vals.get('regions') : null),
          valid_from: (vals.has('valid_from') ? vals.get('valid_from') : null),
          valid_to: (vals.has('valid_to') ? vals.get('valid_to') : null),
          period_length: (vals.has('period_length') ? vals.get('period_length') : null),
          period_time_unit: (vals.has('period_time_unit') ? vals.get('period_time_unit') : null),
          flyprivate_platform_tier_pricing_id: (vals.has('flyprivate_platform_tier_pricing_id') ? vals.get('flyprivate_platform_tier_pricing_id') : null),
          currency_cd: (vals.has('currency_cd') ? vals.get('currency_cd') : null),
          utc_flag: (vals.has('utc_flag') ? vals.get('utc_flag') : null)
        }]

      const getRegions = (regions) => {
        if (!regions || !regions.length || regions === 'WW') {
          return regions
        }
        const splitRegions = (regions.charAt(0) === '-' ? regions.substring(1) : regions).split(',')
        return regions.charAt(0) === '-'
          ? countries.map(country => !splitRegions
            .find(region => region === country.value) && country.value)
            .filter(result => result && result.length <= 2)
          : splitRegions
      }

      items2.forEach(item2 => {
        items1.forEach(item1 => {
          const differentID = ((!item1.id && item2.id) ||
            (item1.id && !item2.id) ||
            (item1.id && item2.id && item1.id !== item2.id) ||
            (item1.control_timestamp && item2.control_timestamp && item1.control_timestamp !== item2.control_timestamp)
          )
          const typeSaleControl = true
          /*
          const pricings = store.options.has('flyprivate_pricings') ? store.options.get('flyprivate_pricings') : null
          if (pricings) {
            const typeSale = id => pricings.find(p => p.id === id)
            const typeS1 = typeSale(item1.flyprivate_platform_tier_pricing_id)
            const typeS2 = typeSale(item2.flyprivate_platform_tier_pricing_id)
            typeSaleControl = exclude && Array.isArray(exclude) && exclude.length === 3 &&
              typeS2 && typeS2.type_sale && typeS2.type_sale === exclude[1]
              ? typeS2.type_sale === exclude[2]
              : typeS1.type_sale === typeS2.type_sale
          }
          */
          const periodControl = saleType && saleType === 'SVOD' && item1.period_time_unit && item2.period_time_unit && item1.period_length && item2.period_length
            ? item1.period_time_unit === item2.period_time_unit && parseInt(item1.period_length) === parseInt(item2.period_length)
            : true
          if (!errors && differentID && typeSaleControl && periodControl) {
            if ((item1.regions && item1.regions === 'WW') ||
              (item2.regions && item2.regions === 'WW')
            ) {
              if (_datesOverlapping(item1.valid_from, item1.valid_to, item2.valid_from, item2.valid_to, 'WW', false, false, store)) {
                errors = store.__('Duplicate pricing, because World wide (WW) region is in use and dates are overlapping.')
              }
            } else if (!item1.regions && !item2.regions) {
              errors = store.__('Duplicate pricing, because missing regions. ')
            } else {
              const regions1 = item1.regions && getRegions(item1.regions)
              const regions2 = item2.regions && getRegions(item2.regions)
              const duplicates = []

              item1.currency_cd && item2.currency_cd &&
                item1.currency_cd === item2.currency_cd &&
                regions1 && regions1.forEach(country => {
                if (regions2 && regions2.find(region =>
                  region === country &&
                  _datesOverlapping(
                    item1.valid_from, item1.valid_to, item2.valid_from, item2.valid_to,
                    region,
                    item1.utc_flag && (item1.utc_flag > 0 || item1.utc_flag === 'true' || item2.utc_flag === true),
                    item2.utc_flag && (item1.utc_flag > 0 || item2.utc_flag === 'true' || item2.utc_flag === true),
                    store
                  )
                )) {
                  duplicates.push(country)
                }
              })

              const from1 = item1.valid_from ? moment(item1.valid_from).utc().format(defaultConst.DATE_FORMAT_FULL) : ''
              const from2 = item2.valid_from ? moment(item2.valid_from).utc().format(defaultConst.DATE_FORMAT_FULL) : ''
              const to1 = item1.valid_to ? moment(item1.valid_to).utc().format(defaultConst.DATE_FORMAT_FULL) : ''
              const to2 = item2.valid_to ? moment(item2.valid_to).utc().format(defaultConst.DATE_FORMAT_FULL) : ''

              errors = duplicates.length > 0 &&
                store.__('Duplicate between pricing ID ') + item1.id +
                 ' (' + (item1.utc_flag ? 'UTC ' : '') +
                 (from1 || '?') + ' / ' + (to1 || '?') + ') ' +
                store.__(' and pricing ID ') + (item2.id || store.__('-new-')) +
                 ' (' + (item2.utc_flag ? 'UTC ' : '') +
                 (from2 || '?') + ' / ' + (to2 || '?') + ') ' +
                store.__(' for regions: ') + duplicates.join(', ') + '. '
            }
          }
        })
      })
    }
    return errors || undefined
  }
  return _regionOverlapping
}

function positiveInt (store) {
  function _positiveInt (val) {
    const v = parseInt(val)
    if (val && (isNaN(v) || v <= 0)) {
      return store.__('Not valid positive integer. ')
    }
  }
  return _positiveInt
}

function positiveFloat (store, zero) {
  function _positiveFloat (val) {
    const v = parseFloat(val)
    if (val && (isNaN(v) || zero ? v < 0 : v <= 0)) {
      return store.__('not valid positive decimal value. ')
    }
  }
  return _positiveFloat
}

function maxLength (store, len) {
  function _maxLength (val) {
    if (val && val.length > len) {
      return store.__('Too long value. Maximum is ' + len + '. ')
    }
  }
  return _maxLength
}

function maxIntValue (store, max) {
  function _maxIntValue (val) {
    if (val && parseInt(val) > max) {
      return store.__('You exceeded maximum value established to ' + max + '. ')
    }
  }
  return _maxIntValue
}

function isEmail (store) {
  function _isEmail (val) {
    if (val && (val.indexOf('@') <= 0 || val.indexOf('.') <= 0)) {
      return store.__('The inserted value is not a valid email address. ')
    }
  }
  return _isEmail
}
